"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Menu = (function () {
    function Menu() {
        this.menuToggle = document.querySelector(' .menuToggle');
        this.listenLiveMenuItem = document.querySelector('.menuList #openLivePlayer');
        this.menuToggle.addEventListener('click', this.onMenuToggleClick.bind(this));
        window.addEventListener('resize', this.handleResize.bind(this));
        window.addEventListener('click', this.closeMenu.bind(this));
        this.listenLiveMenuItem.addEventListener('click', this.openPopup.bind(this));
    }
    Menu.getInstance = function () {
        if (!this.instance) {
            this.instance = new Menu();
        }
        return this.instance;
    };
    Menu.prototype.openPopup = function (e) {
        e.preventDefault();
        var w = window.open('/player/live', '_blank', "width=380,scrollbars=1,height=" + (window.screen.height - 100));
        if (w) {
            w.opener = null;
        }
    };
    Menu.prototype.onMenuToggleClick = function (e) {
        e.stopPropagation();
        document.querySelector('nav.menu').classList.toggle('opened');
        document.querySelector('.menuList').classList.toggle('menuToggled');
        document.querySelector('body').classList.toggle('disable-scroll');
    };
    Menu.prototype.closeMenu = function () {
        document.querySelector('nav.menu').classList.remove('opened');
        document.querySelector('.menuList').classList.remove('menuToggled');
        document.querySelector('body').classList.remove('disable-scroll');
    };
    Menu.prototype.handleResize = function () {
        if (window.innerWidth >= 768) {
            this.closeMenu();
        }
    };
    return Menu;
}());
exports.default = Menu;
